import { Link } from "react-router-dom";
import React, { useState } from "react";
import { Button, Col, Form, Input, Row, Select, Grid, Popconfirm } from "antd";

import { PropriedadesDoPopConfirm } from "@/Defaults";
import { ITutorial } from "@/Components/Ajuda";
import AjudaComDropdown from "@/Components/Ajuda";

import { PerfilService, useListarPerfis } from "@/Services/Sistema/PerfilService";
import { TypePerfil } from "@/Models/Pessoa/Perfil";

import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";

import { useRequerPermissoes } from "@/Hooks/useRequerPermissoes";
import { PerfilTableBasic } from "./PerfilTableBasic";

import "@/Styles/Perfil.css"
import * as Tutoriais from "./perfil.tutorial"
import { VinculoDePerfilModal } from "./VinculoDePerfil";
import { ControleDePermissoesModal } from "./ControleDePermissoes";

export const PerfilConsulta: React.FC<{
    hrefDoBotaoAdicionar?: string,
    hrefDoBotaoEditar?: (perfil: TypePerfil) => string | void,
}> = (props) => {

    type Formulario = {
        nome: string,
        ativo: boolean,
    }

    const [filtro, setFiltro] = useState<TypePerfil>({});
    const perfisQuery = useListarPerfis({ config: {enabled: true}, params: [filtro] });
    const permissoes = useRequerPermissoes();

    const onFinish = (values: Formulario) => {
        const f: TypePerfil = {
            nome: values.nome,
            ativo: values.ativo,
        }

        setFiltro(f);
    }

    return (
        <>
            <Form name="listar" onFinish={onFinish} layout="vertical">
                <Row id={Tutoriais.IDs.formularioDeFiltro} gutter={16}>
                    <Col xs={24} md={12} id={Tutoriais.IDs.filtroDeNome}>
                        <Form.Item<Formulario> name="nome" label="Nome">
                            <Input placeholder="Todos" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} md={6} id={Tutoriais.IDs.filtroDeAtivo}>
                        <Form.Item<Formulario> name="ativo" label="Ativo" initialValue={true}>
                            <Select
                                allowClear
                                placeholder="Todos"
                                options={[
                                    { value: true, label: "Ativo" },
                                    { value: false, label: "Inativo" },
                                ]}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={12} md={3} style={{ alignItems: "end", display: "flex" }}>
                        <Form.Item style={{ flexGrow: 1 }}>
                            <Button
                                type="primary"
                                key="submit"
                                htmlType="submit"
                                id={Tutoriais.IDs.botaoListar}
                                style={{ width: "100%" }}
                                disabled={perfisQuery.isFetching || !permissoes?.todas("ListarPerfis")}
                            >
                                Listar
                            </Button>
                        </Form.Item>
                    </Col>

                    <ComponentePermissao permissoes={["CriarPerfil"]}>
                        <Col xs={12} md={3} style={{ alignItems: "end", display: "flex" }}>
                            <Form.Item style={{ flexGrow: 1 }}>
                                <Link
                                    to={props.hrefDoBotaoAdicionar ?? "#"}
                                    onClick={(e) => {
                                        !props.hrefDoBotaoAdicionar && e.preventDefault();
                                    }}
                                >
                                    <Button type="primary" style={{ width: "100%" }}>
                                        Adicionar
                                    </Button>
                                </Link>
                            </Form.Item>
                        </Col>
                    </ComponentePermissao>
                </Row>
            </Form>

            <Row>
                <Col xs={24}>
                    <PerfilTableBasic
                        tableProps={{ dataSource: perfisQuery.data?.data, loading: perfisQuery.isFetching }}
                        hideActions={!permissoes?.alguma("AtualizarPerfil", "DesativarPerfil", "AtivarPerfil")}
                        actions={(item) => {
                            if (item.ativo) {
                                return [
                                    permissoes?.todas("AtualizarPerfil") && (
                                        <Link to={props.hrefDoBotaoEditar?.(item) ?? "#"} onClick={(e) => !props.hrefDoBotaoEditar && e.preventDefault()}>
                                            <Button className={Tutoriais.Classes.botaoEditar} type="primary" size="small">
                                                Editar
                                            </Button>
                                        </Link>
                                    ),

                                    permissoes?.todas("DesativarPerfil") && (
                                        <Popconfirm
                                            {...PropriedadesDoPopConfirm("desativar")}
                                            onConfirm={() => {
                                                if (item.codigo) {
                                                    PerfilService.desativar(item.codigo)
                                                        .then(() => {
                                                            perfisQuery.refetch();
                                                        })
                                                        .catch(() => {});
                                                }
                                            }}
                                        >
                                            <Button type="default" danger size="small" className={Tutoriais.Classes.botaoDesativar}>
                                                Desativar
                                            </Button>
                                        </Popconfirm>
                                    ),

                                    permissoes?.todas("VincularPerfilAoUsuario") && item.codigo && (
                                        <VinculoDePerfilModal
                                            buttonOpen={
                                                <Button type="default" size="small">
                                                    Usuários
                                                </Button>
                                            }
                                            modalProps={{
                                                title: "Vincular perfil a usuários",
                                                styles: {body: {maxHeight: "60vh", overflowY: "auto", overflowX: "hidden", scrollbarWidth: "thin"}}
                                            }}
                                            codPerfil={item.codigo}
                                        />
                                    ),

                                    permissoes?.todas("ConfigurarPermissoesDoPerfil") && item.codigo && (
                                        <ControleDePermissoesModal
                                            buttonOpen={
                                                <Button type="default" size="small">
                                                    Permissões
                                                </Button>
                                            }
                                            modalProps={{
                                                title: `Permissões para o perfil "${item.nome}"`,
                                            }}
                                            codPerfil={item.codigo}
                                        />
                                    ),
                                ];
                            } else {
                                return [
                                    permissoes?.todas("AtivarPerfil") && (
                                        <Popconfirm
                                            {...PropriedadesDoPopConfirm("ativar")}
                                            onConfirm={() => {
                                                if (item.codigo) {
                                                    PerfilService.ativar(item.codigo)
                                                        .then(() => {
                                                            perfisQuery.refetch();
                                                        })
                                                        .catch(() => {});
                                                }
                                            }}
                                        >
                                            <Button type="dashed" size="small">
                                                Reativar
                                            </Button>
                                        </Popconfirm>
                                    ),
                                ];
                            }
                        }}
                        actionsBreakpoints={{ lg: 4, xs: 24 }}
                    />
                </Col>
            </Row>

            <AjudaComDropdown
                tutoriais={
                    [
                        {
                            titulo: "Como consultar perfis",
                            tutorial: Tutoriais.ConsultarPerfil,
                        },

                        permissoes?.todas("CriarPerfil") && {
                            titulo: "Como cadastrar um novo perfil",
                            tutorial: Tutoriais.AdicionarPerfil,
                        },

                        permissoes?.alguma("VincularPerfilAoUsuario") && {
                            titulo: "Como vincular um perfil a um usuário",
                            tutorial: Tutoriais.VincularPerfil,
                        },

                        permissoes?.todas("AtualizarPerfil") && {
                            titulo: "Como editar um perfil",
                            tutorial: Tutoriais.EditarPerfil,
                        },

                        permissoes?.todas("DesativarPerfil") && {
                            titulo: "Como desativar um perfil",
                            tutorial: Tutoriais.DesativarPerfil,
                        },
                    ].filter((v) => v != false) as ITutorial[]
                }
            />
        </>
    );
};
